import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import LogoImage from '~/assets/images/logo-gmoask.png';
import { FONT_SIZES, FONT_WEIGHTS, Z_INDEX } from '~/assets/styles/base';
import { ROUTES } from '~/constants/routes';

type WrapperProps = {
  $height: string;
  $bgColor?: string;
};

const Wrapper = styled.div<WrapperProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 20px;
  width: 100%;
  height: ${({ $height }) => $height};
  background-color: ${({ $bgColor }) => $bgColor};
  position: fixed;
  margin-top: var(--gmo-header-height, 28px);
  z-index: ${Z_INDEX.header};
`;

const Tools = styled.div`
  margin-left: auto;
`;

const Img = styled.img`
  display: block;
  height: 19.4px;
  &:hover {
    cursor: pointer;
  }
`;

const AdminBox = styled.div`
  font-size: ${FONT_SIZES.modalInputDefault};
  font-weight: ${FONT_WEIGHTS.size3};
  margin-left: 24px;
`;
type Props = {
  children: JSX.Element;
  height: string;
  bgColor?: string;
  isAdmin?: boolean;
};

const HeaderBarWithToolButtons: React.FC<Props> = ({
  height,
  children,
  isAdmin = false,
  bgColor = 'inhelit',
}): JSX.Element => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <Wrapper $height={height} $bgColor={bgColor} data-testid="uiParts-HeaderBarWithToolButtons">
      <Img
        src={LogoImage}
        alt="GMO Ask"
        title="GMO Ask"
        onClick={() => navigate(isAdmin ? ROUTES.ADMIN.SIGNIN : ROUTES.USER.SIGNIN)}
      />
      {isAdmin && (
        <AdminBox data-testid="uiParts-HeaderBarWithToolButtons-AdminBox">
          {t('adminSignin.adminView')}
        </AdminBox>
      )}
      <Tools>{children}</Tools>
    </Wrapper>
  );
};

export default HeaderBarWithToolButtons;
